import {appendMarkdown} from "./appendMarkdown.js";
import {blockQuoteString} from "./blockQuote.js";

export function appendBlockQuote(content) {
  return ({state, dispatch}) => {
    dispatch({
      ...appendMarkdown(state, blockQuoteString(content)),
      userEvent: "input.appendBlockQuote"
    });
  };
}
